<template>
  <div class="pb-5">
    <nav-bar/>
    <sidebar-toggle-button/>
    <chat-page/>
    <ticket-button/>

    <!-- Sidebar -->
    <div class="sidebar bg-darkgrey navbar-inverse side-box-shadow" v-if="$store.state.isSidebarOpen">
      <ul class="nav flex-column">
        <li class="nav-item" id="current">
          <a class="nav-link navbar-text pull-left" href="#/OrderPending">{{$t('OrderPending.sidebar.pending')}}</a>
          <span v-if="orders.length > 0" class="pull-right badge badge-default">{{ orders.length }}</span>
        </li>
        <li class="nav-item">
          <a class="nav-link navbar-text pull-left" href="#/OrderCurrent">{{$t('OrderPending.sidebar.current')}}</a>
        </li>
      </ul>
      <a class="color-white btn btn-kne-orange col-12 mt-3" href="#/OrderCurrent?newOrder=true">
        <i class="fa fa-plus-circle fa-lg" aria-hidden="true"></i>
        {{$t('OrderPending.sidebar.add_order')}}
      </a>
    </div>
    <!-- Sidebar End -->

    <table-element
      :isShowFilter="true"
      :title="$t('OrderPending.title')"
      :fields="fieldsObj"
      :arrOfElement="orders"
      :sortSpacing="0"
      class="card mx-2 my-5"
      @updateFilterResults="updateFilterResults"
    >
      <template #header-actions>
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="order in content.results"
          :key="order['.key']"
          class="table-element_hover"
        >
          <td class="nowrap">{{order.numRef}}</td>
          <!-- <td v-if="hasIntegration" class="nowrap">
            <i v-if="order.isDivisionX" class="fa fa-check" aria-hidden="true"></i>
          </td> -->
          <td class="nowrap">{{order.vin || '-'}}</td>
          <td class="nowrap"><p class="table-fix-width">{{order.source || '-'}}</p></td>
          <td class="nowrap">{{ getDate(order.creationDate) || '-'}}</td>
          <td class="nowrap"><p class="table-fix-width">{{order.transmitterName || '-'}}</p></td>
          <td class="nowrap"><p class="table-fix-width">{{order.receiverName || '-'}}</p></td>
          <td class="nowrap"><p class="table-fix-width">{{order.payerName || '-'}}</p></td>
          <td>
            <div class="pull-right mr-2" id="action">
              <!-- COMMENTED ON PROD -->
              <!-- <button class="btn btn-kne-orange" :disabled="inProgress === order['.key']" @click="openPrice(order)">
                <i class="fa fa-check" aria-hidden="true"></i>
              </button> -->

              <!-- [DEV] UNCOMMENTED ON PROD -->
              <button v-if="isSageOne || isQuickBook" class="btn btn-kne-orange" :disabled="inProgress === order['.key']" @click="openPrice(order)">
                <i class="fa fa-check" aria-hidden="true"></i>
              </button>
              <button v-else class="btn btn-kne-orange" :disabled="inProgress === order['.key']" @click.once="action(order, true)">
                <i class="fa fa-check" aria-hidden="true"></i>
              </button>
              <button class="ml-2 btn btn-kne-orange" :disabled="inProgress === order['.key']" @click.once="action(order, false)">
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </td>
        </tr>
      </template>

      <template #body-content-mobile="content">
        <!-- List of orders -->
        <transition-group name="fade">
          <div class="card my-3 mx-2" v-for="order in content.results" :key="order['.key']">
            <div class="card-header m-2">
              <h4>{{order.source || '-'}}</h4>
              <h6><i class="fa fa-calendar mr-1"></i> {{ getDate(order.creationDate) || '-'}}</h6>
            </div>
            <div class="m-2">
              <p><i class="fa fa-asterisk"></i> {{order.numRef || '-'}}</p>
              <p><i class="fa fa-car"></i> {{order.vin || '-'}}</p>
              <p><i class="fa fa-home"></i> {{order.transmitterName || '-'}}</p>
              <p><i class="fa fa-truck"></i> {{order.receiverName || '-'}}</p>
              <p><i class="fa fa-credit-card"></i> {{order.payerName || '-'}}</p>
            </div>
            <div id="action">
              <button v-if="isSageOne || isQuickBook" class="btn btn-kne-orange m-2" :disabled="inProgress === order['.key']" @click="openPrice(order)">
                <i class="fa fa-check" aria-hidden="true"></i>
              </button>
              <button v-else class="btn btn-kne-orange m-2" :disabled="inProgress === order['.key']" @click.once="action(order, true)">
                <i class="fa fa-check" aria-hidden="true"></i>
              </button>
              <button class="btn btn-kne-orange m-2" :disabled="inProgress === order['.key']" @click.once="action(order, false)">
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </transition-group>
      </template>
    </table-element>

    <loading-render v-if="isLoading" />

    <!-- Modal OpenPrice -->
    <transition name="fade">
      <modal
        :title="$t('OrderPending.orderTab.confirmPrice')"
        v-if="modal.openPrice"
        @close-request="modal.openPrice = false; clear()"
        closable
      >

        <div class="col-12">
          <div class="flexContainer m-2" :class="{'mobileFlexContainer' : isScreenSmall}">
            <div class="addressInfoContainer">

              <div>
                <h4 class="mt-3">{{$t('OrderInfo.modal.pickup.title')}}</h4>
                <strong>{{selectedOrder.transmitterName}}: </strong>
                {{selectedOrder.transmitterAddress}},
                {{selectedOrder.transmitterCity}},
                {{selectedOrder.transmitterCountry}},
                {{selectedOrder.transmitterPostcode}},
                {{selectedOrder.transmitterProvince}}
              </div>

              <div>
                <h4 class="mt-3">{{$t('OrderInfo.modal.delivery.title')}}</h4>
                <strong>{{selectedOrder.receiverName}}: </strong>
                {{selectedOrder.receiverAddress}},
                {{selectedOrder.receiverCity}},
                {{selectedOrder.receiverCountry}},
                {{selectedOrder.receiverPostcode}},
                {{selectedOrder.receiverProvince}}
              </div>

              <div>
                <h4 class="mt-3">{{$t('OrderInfo.modal.billing.title')}}</h4>
                <strong>{{selectedOrder.payerName}}: </strong>
                {{selectedOrder.payerAddress}},
                {{selectedOrder.payerCity}},
                {{selectedOrder.payerCountry}},
                {{selectedOrder.payerPostcode}},
                {{selectedOrder.payerProvince}}
              </div>
            </div>

            <div class="carInfoContainer" :class="{'ml-2' : !isScreenSmall}">
              <div>
                <h4 class="mt-3">{{$t('OrderPending.vehicleInfoTab.year')}}</h4>
                <span v-if="selectedOrder.year">{{selectedOrder.year}}</span>
                <span v-else> <i class="fa fa-times-circle" style="font-size: 1.5rem;"></i> </span>
              </div>

              <div>
                <h4 class="mt-3">{{$t('OrderPending.vehicleInfoTab.make')}}</h4>
                <span v-if="selectedOrder.make">{{selectedOrder.make}}</span>
                <span v-else> <i class="fa fa-times-circle" style="font-size: 1.5rem;"></i> </span>
              </div>

              <div>
                <h4 class="mt-3">{{$t('OrderPending.vehicleInfoTab.model')}}</h4>
                <span v-if="selectedOrder.model">{{selectedOrder.model}}</span>
                <span v-else> <i class="fa fa-times-circle" style="font-size: 1.5rem;"></i> </span>
              </div>
            </div>

            <div class="miscContainer" :class="{'ml-2' : !isScreenSmall}">
              <div>
                <h4 class="mt-3">{{$t('OrderPending.signatory')}}</h4>
                <span v-if="selectedOrder.dateSignataire"> {{selectedOrder.dateSignataire}} {{selectedOrder.signataire}}</span>
                <span v-else> <i class="fa fa-times-circle" style="font-size: 1.5rem;"></i> </span>
              </div>

              <div class="miscContent">
                <h4 class="mt-3">{{$t('OrderCurrent.modal.documents')}}</h4>
                <a v-if="selectedOrder.docs" :href="selectedOrder.docs" target="_blank"> {{selectedOrder.docs}}</a>
                <span v-else> <i class="fa fa-times-circle" style="font-size: 1.5rem;"></i> </span>
              </div>

              <div class="miscContent">
                <h4 class="mt-3">{{$t('OrderCurrent.modal.size')}}</h4>
                <span v-if="selectedOrder.size"> {{selectedOrder.size}}</span>
                <span v-else> <i class="fa fa-times-circle" style="font-size: 1.5rem;"></i> </span>
              </div>
            </div>

          </div>

          <div class="toggleSwitch">
              <toggle-switch
                ref="toggleSwitch"
                :optionList="buttonList"
                :multiple="false"
                @emitSelectedOption="updateOptionSelect"
                @getMakeModel="returnMakeModel"
              />
              <hover-tool-tip
                class="mx-2"
                :clickable="false"
                :text="sizeTooltipText"
                :iconColor="sizeTooltipColor"
                top
                right
              />
          </div>

          <div>
            <button v-if="selectedOrder.transmitterName && selectedOrder.receiverName && companyUID === 'e58ff614-8449-4c3e-90b8-b42a48c2972b'" class="btn btn-kne-orange w-100 form-group mt-2"
            @click="validatePricing(selectedOrder.transmitterPostcode.substr(0, 3) + '-' + selectedOrder.receiverPostcode.substr(0, 3))">{{$t('OrderPending.vehicleInfoTab.validate')}}</button>
          </div>
        </div>

          <div class="col-12 mt-4">
            <h4 class="kne-title">{{$t('OrderCurrent.modal.pricing')}}</h4>

            <div v-if="companyUID === 'e58ff614-8449-4c3e-90b8-b42a48c2972b'" class="table-responsive">
              <table class="table table-hover">
                <thead class="">
                <tr>
                  <th>{{$t('General.number')}}</th>
                  <th>{{$t('OrderCurrent.modal.regularPrice')}}</th>
                  <th>{{$t('OrderCurrent.modal.discount')}}</th>
                  <th>{{$t('OrderCurrent.modal.surplus')}}</th>
                  <th>{{$t('OrderCurrent.billing')}}</th>
                  <th>{{$t('OrderCurrent.modal.estimatedDelay')}}</th>
                  <th>{{$t('OrderCurrent.modal.delay')}}</th>
                  <th>{{$t('OrderCurrent.modal.vehicles')}}</th>
                  <th>{{$t('OrderCurrent.modal.count')}}</th>
                  <th>{{$t('OrderCurrent.modal.size')}}</th>
                </tr>
                </thead>
                <transition-group name="fade" tag="tbody">
                  <tr v-for="(vehicle, index) in pricingAndDelay" :key="vehicle.pricing + index">
                    <td>{{index}}</td>
                    <td>{{vehicle.price}}$</td>
                    <td>{{vehicle.discount}}$</td>
                    <td>{{vehicle.surplus}}$</td>
                    <td>{{selectedOrder.payerName}}</td>
                    <td>{{vehicle.dateExpected}}</td>
                    <td>{{vehicle.delay}}</td>
                    <td>{{vehicle.makeModelYear}}</td>
                    <td>{{vehicle.count}}</td>
                    <td>{{vehicle.size}}</td>
                  </tr>
                </transition-group>
              </table>
            </div>
          <div class="mt-3" id="priceSection">
            
            <p class="col-12 form-group text-center"><strong id="suggested_price" class="p-2 px-5">{{$t('OrderPending.suggested_price')}}: {{returnSuggestedPrice || $t('General.not_found')}} </strong></p>
            <label>{{$t('OrderCurrent.modal.regularPrice')}} ($)</label>
              <hover-tool-tip
                class="mx-2"
                :clickable="false"
                :text="priceTooltipText"
                :iconColor="priceTooltipColor"
                top
                right
            />
            <regular-input-number
              :value="selectedOrder.regularPrice"
              @input="calculateCarPrice(selectedOrder.regularPrice = $event); selectedOrder.regularPrice = $event"
              :placeholder="'0'" class="col-12 form-group" min="0"/>

            <label>{{$t('OrderCurrent.modal.discount')}} (%)</label>
            <regular-input-number
              :value="selectedOrder.discount"
              @input="calculateCarPrice(selectedOrder.discount = $event)"
              :placeholder="'0'" class="col-12 form-group" min="0"/>

            <label>{{$t('OrderCurrent.modal.surplus')}} (%)</label>
            <regular-input-number
              :value="selectedOrder.surplus"
              @input="calculateCarPrice(selectedOrder.surplus = $event)"
              :placeholder="'0'" class="col-12 form-group" min="0"/>

            <label>{{$t('OrderPending.orderTab.price')}} ($)</label>
            <regular-input-number
              :value="selectedOrder.price"
              :disabled="true"
              :placeholder="'0'" class="col-12 form-group"/>

            <label>{{$t('OrderPending.orderTab.datePromis')}}</label>
            <regular-input
            :value="selectedOrder.datePromis"
            @input="selectedOrder.datePromis = $event"
            type="date" :placeholder="$t('OrderPending.orderTab.datePromis')" class="col-12 form-group"/>

            <label>{{$t('OrderPending.orderTab.dateExpected')}}</label>
            <regular-input-number
              :value="order.dateExpected"
              @input="order.dateExpected = $event"
              :placeholder="$t('OrderPending.orderTab.dateExpected')"
              class="col-12 form-group"/>
            </div>
          </div>

        <div class="col-12">
          <button class="btn btn-kne-orange w-100" :disabled="selectedOrder.price === ''" @click.once="action(selectedOrder, true)">{{$t('OrderPending.submitOrder')}}</button>
        </div>

      </modal>
    </transition>
  </div>
</template>

<script>
import Modal from '../module/interface-components/Modal.vue'
import regularInput from '../module/basic-components/regularInput.vue'
import HoverToolTip from '../module/basic-components/HoverToolTip.vue'
import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
import regularTextarea from '../module/basic-components/regularTextarea.vue'
import regularSelect from '../module/basic-components/regularSelect.vue'
import Search from '../module/special-components/Other-components/Search.vue'
import {db} from '../../firebase'
import _ from 'lodash'
import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
import ChatPage from '../module/interface-components/ChatPage.vue'
import regularInputNumber from '../module/basic-components/regularInputNumber.vue'
import TicketButton from '../module/interface-components/TicketButton.vue'
import TableElement from '../module/special-components/Table-component/Table-Element.vue'
import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
import ToggleSwitch from '../module/special-components/Other-components/ToggleSwitch.vue'

export default {
  name: 'orderPending',
  components: {
    Modal,
    regularInput,
    regularCheckbox,
    regularTextarea,
    regularInputNumber,
    Search,
    SidebarToggleButton,
    regularSelect,
    ChatPage,
    TicketButton,
    TableElement,
    LoadingRender,
    ToggleSwitch,
    HoverToolTip
  },

  data () {
    return {
      addressbook: [],
      billingSame: false,
      deliverySave: false,
      VIN: '',
      MAKE: '',
      MODEL: '',
      YEAR: '',
      SIZE: '',
      vehicles: [],
      pricingAndDelay: [],
      pickupSave: false,
      inProgress: '',
      filterResults: [],
      orders: [],
      selectedOrder: {},
      searchHistory: [],
      searchType: '',
      searchText: '',
      historyTypeTag: '',
      sizeTooltipText: '',
      priceTooltipText: '',
      sizeTooltipColor: '',
      priceTooltipColor: '',

      backup: {
        sageIDDelivery: ''
      },
      datalist: {
        pickup: '',
        pickupUid: '',
        delivery: '',
        deliveryUid: '',
        billing: '',
        billingUid: ''
      },
      fields: {
        numRef: '',
        vin: '',
        source: '',
        creationDate: '',
        receiverAddress: '',
        transmitterAddress: '',
        payerAddress: ''
      },
      suggestedPrice: 0,
      modal: {
        openPrice: false
      },
      order: {
        comment: '',
        latitude: 0.001,
        longitude: 0.001,
        make: '',
        model: '',
        datePromis: '',
        dateExpected: '',
        nbDispatch: 0,
        numRef: '',
        payer: '',
        payerAddress: '',
        payerCity: '',
        payerContact: '',
        payerFax: '',
        payerName: '',
        payerPhone: '',
        payerEmail: '',
        payerPostcode: '',
        payerCountry: '',
        payerProvince: '',
        receiver: '',
        receiverAddress: '',
        receiverCity: '',
        receiverContact: '',
        receiverFax: '',
        receiverName: '',
        receiverPhone: '',
        receiverEmail: '',
        receiverPostcode: '',
        receiverCountry: '',
        receiverProvince: '',
        status: 'Processing',
        source: '',
        transmitter: '',
        transmitterAddress: '',
        transmitterCity: '',
        transmitterContact: '',
        transmitterFax: '',
        transmitterName: '',
        transmitterPhone: '',
        transmitterEmail: '',
        transmitterPostcode: '',
        transmitterCountry: '',
        transmitterProvince: '',
        transpCigle: '',
        transpName: '',
        vin: '',
        year: '',
        regularPrice: 0,
        price: 0,
        discount: 0,
        surplus: 0
      },
      fieldsObj: [
       {
         text: this.$t('OrderCurrent.reference'),
         type: 'numRef',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.VIN'),
         type: 'vin',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.source'),
         type: 'source',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.date'),
         type: 'creationDate',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.pickup'),
         type: 'transmitterName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.delivery'),
         type: 'receiverName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.billing'),
         type: 'payerName',
         value: ''
       },
       {
         text: '',
         type: '',
         value: ''
       }
      ],

      buttonList: {
        heavy: {
          id: 4,
          label: this.$t('OrderCurrent.modal.heavy'),
          value: 'Heavy',
          selected: false,
          selectedBgColor: 'rgb(255, 178, 84, 30)'
        },
        medium: {
          id: 3,
          label: this.$t('OrderCurrent.modal.medium'),
          value: 'Medium',
          selected: false,
          selectedBgColor: 'rgb(255, 178, 84, 30)'
        },
        light: {
          id: 2,
          label: this.$t('OrderCurrent.modal.light'),
          value: 'Light',
          selected: false,
          selectedBgColor: 'rgb(255, 178, 84, 30)'
        },
        noSize: {
          id: 1, // If you change this id, also change it in @function setVehicleSize
          label: this.$t('OrderCurrent.modal.nosize'),
          value: 'No Size',
          selected: true,
          selectedBgColor: 'rgb(255, 178, 84, 30)'
        }
      }
    }
  },

  created () {
    this.isLoading = true
    this.$store.state.isSidebarOpen = false
    this.isScreenSmall = window.innerWidth < 800
    var id = this.companyUID

    this.$bindAsArray('orders', db.ref('database/transporter/' + id + '/unprocessed').orderByChild('creationDate'), null, () => {
      this.isLoading = false
    })
  },

  methods: {
   async openPrice (order) {
      this.modal.openPrice = true
      order.datePromis = ''
      this.selectedOrder = {...order}
      this.suggestedPrice = this.selectedOrder.price
      this.selectedOrder.price = 0

      await this.getVehicleSize(this.returnMakeModel)
      this.setVehicleSize(this.SIZE)
    },

    async getVehicleSize (makeModel) {
      await db.ref(`vehicleSize/${this.companyUID}/${makeModel}`).once('value').then((snapshot) => {
        this.SIZE = snapshot.val()
        this.setSizeTooltipText(true)
      }).catch(() => {
        this.SIZE = '1'
        this.setSizeTooltipText(false)
        console.log('No vehicle size')
      })
    },

    async setVehiclePrice (size) {
      const postcodePath = this.returnPostcodePath
      let dbPath = ''

      if (this.isBillingWholesaleExpress) dbPath = `vehiclePrice/wholesale/${postcodePath}/${size}`
      else dbPath = `vehiclePrice/${this.companyUID}/${postcodePath}/${size}`
      await db.ref(dbPath).once('value').then((snapshot) => {
        this.selectedOrder.regularPrice = parseInt(snapshot.val().regularPrice) || 0
        this.selectedOrder.surplus = parseInt(snapshot.val().tax) || 0
        this.selectedOrder.discount = parseInt(snapshot.val().discount) || 0
        this.setPriceTooltipText(true, this.selectedOrder.regularPrice, this.selectedOrder.surplus, this.selectedOrder.discount)
        this.calculateCarPrice()
      }).catch(() => {
        this.setPriceTooltipText(false)
        this.selectedOrder.regularPrice = 0
        this.selectedOrder.surplus = 0
        this.selectedOrder.discount = 0
        this.calculateCarPrice()
      })
    },

    async setVehicleSize (size) {
      const keys = Object.keys(this.buttonList)

      if (!size) {
        let selectedSize = keys.find(key => this.buttonList[key].id.toString() === '1') // 1 is the id of "no size" in buttonList
        this.$refs.toggleSwitch.onOptionSelect(this.buttonList[selectedSize])
      } else {
        let selectedSize = keys.find(key => this.buttonList[key].id.toString() === size.toString())
        this.$refs.toggleSwitch.onOptionSelect(this.buttonList[selectedSize])
      }
    },

    setSizeTooltipText (isTruthy) {
      if (isTruthy) {
        this.sizeTooltipText = `${this.$t('Vehicle.size_found')} (${this.getStringVehicleSize(this.SIZE)})`
        this.sizeTooltipColor = 'green'
      } else {
        this.sizeTooltipText = this.$t('Vehicle.size_not_found')
        this.sizeTooltipColor = 'red'
      }
    },

    getStringVehicleSize (size = '1') {
      let text = ''
      const keys = Object.keys(this.buttonList)

      text = keys.find(key => this.buttonList[key].id.toString() === size.toString())
      text = this.buttonList[text].label

      return text
    },

    setPriceTooltipText (isTruthy, regularPrice, discount, surplus) {
      if (isTruthy) {
        this.priceTooltipText = `${this.$t('Vehicle.price_found')} (P:${regularPrice}$, ${this.$t('Vehicle.discount_shorthand')}:${discount}%, S:${surplus}%)`
        this.priceTooltipColor = 'green'
      } else {
        this.priceTooltipText = this.$t('Vehicle.price_not_found')
        this.priceTooltipColor = 'red'
      }
    },

    async updateOptionSelect (selectedOption) {
      this.updateMakeModelFirebase(selectedOption.id)
      this.SIZE = selectedOption.id
      await this.setVehiclePrice(this.SIZE)
    },

    updateMakeModelFirebase (vehicleSizeId) {
      db.ref(`vehicleSize/${this.companyUID}/${this.returnMakeModel}`).set(vehicleSizeId)
    },

    updateFilterResults (sortResults) {
      this.filterResults = sortResults
    },

    validatePricing: function (names) {
      window.axios.get('https://dev.transport.keepneye.com/infobemaster/decode/pad/pricing/e58ff614-8449-4c3e-90b8-b42a48c2972b/' + names).then((response) => {
        this.pricingAndDelay = response.data
      }).catch((error) => console.log(error))
    },

    // Called on key events when typing a price in the Add New Order modal
    calculateCarPrice (keyEvent) {
      const discountAmount = ((Number(this.selectedOrder.regularPrice) * Number(this.selectedOrder.discount)) / 100)
      const surplusAmount = ((Number(this.selectedOrder.regularPrice) - discountAmount) * Number(this.selectedOrder.surplus) / 100)
      this.selectedOrder.price = ((Number(this.selectedOrder.regularPrice) - discountAmount) + surplusAmount).toFixed(2)

      this.verifyPriceValues()
    },

    verifyPriceValues () {
      if (this.selectedOrder.regularPrice <= 0) {
        this.selectedOrder.regularPrice = 0
      }

      if (this.selectedOrder.discount <= 0) {
        this.selectedOrder.discount = 0
      }

      if (this.selectedOrder.surplus <= 0) {
        this.selectedOrder.surplus = 0
      }

      if (this.selectedOrder.price <= 0) {
        this.selectedOrder.price = 0
      }
    },

    onInputBillingSame: function () {
      if (this.billingSame) {
        this.order.payerAddress = this.order.receiverAddress
        this.order.payerCity = this.order.receiverCity
        this.order.payerContact = this.order.receiverContact
        this.order.payerFax = this.order.receiverFax
        this.order.payerName = this.order.receiverName
        this.order.payerPhone = this.order.receiverPhone
        this.order.payerEmail = this.order.receiverEmail
        this.order.payerPostcode = this.order.receiverPostcode
        this.order.payerProvince = this.order.receiverProvince
        this.order.payerCountry = this.order.receiverCountry
      }
    },

    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString()
    },

    action: function (order, accept) {
      this.inProgress = order['.key']

      var cigle = this.$store.state.userInfo.cigle
      var name = this.$store.state.userInfo.name
      var newPending = JSON.parse(JSON.stringify(order))

      newPending.transpCigle = cigle
      newPending.transpName = name

      if (!accept) newPending.status = 'Cancel'
      else newPending.status = 'Processing'

      if (order.isPrinted) order.isPrinted = false
      var key = newPending['.key']
      delete newPending['.key']

      // Save price information depending on Postcode, MakeModel and size
      if (this.isSageOne || this.isQuickBook) {
        let dbPath = ''

        if (this.isBillingWholesaleExpress) dbPath = `vehiclePrice/wholesale/${this.returnPostcodePath}/${this.SIZE}`
        else dbPath = `vehiclePrice/${this.companyUID}/${this.returnPostcodePath}/${this.SIZE}`
        db.ref(dbPath).set({
          regularPrice: this.selectedOrder.regularPrice,
          discount: this.selectedOrder.discount,
          tax: this.selectedOrder.surplus
        })
      }

      db.ref('test/transporter/' + this.companyUID + '/pendingDeliveries').child(key).set(newPending).then((snapshot) => {
        // ======================== ADD PENDING ORDER ACTION LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': accept ? 'ACCEPTED_PENDING_ORDER' : 'REJECTED_PENDING_ORDER', 'date': Date.now(), 'targetName': order.source})
        // ======================== ADD PENDING ORDER ACTION LOG =======================
        this.inProgress = ''
        this.modal.openPrice = false
      }).catch(function (error) {
        console.log(error)
      })
    },

    addVehicle: function () {
      this.vehicles.push({
        vin: this.VIN,
        make: this.MAKE,
        model: this.MODEL,
        year: this.YEAR,
        size: this.SIZE
      })

      this.VIN = ''
      this.MAKE = ''
      this.MODEL = ''
      this.YEAR = ''
    },

    clear: function () {
      for (let attr in this.order) {
        this.order[attr] = ''
      }
      for (let attr in this.datalist) {
        this.datalist[attr] = ''
      }
      this.order.status = 'Processing'
      this.order.latitude = 0
      this.order.longitude = 0
      this.order.nbDispatch = 0
      this.suggestedPrice = 0
      this.vehicles = []
      this.pricingAndDelay = []
      this.selectedOrder.originalPrice = 0
      this.selectedOrder.discount = 0
      this.selectedOrder.surplus = 0
      this.selectedOrder.regularPrice = 0
      this.VIN = ''
      this.MAKE = ''
      this.MODEL = ''
      this.YEAR = ''
      this.SIZE = ''
    },

    validate: function (vin) {
      // vin test: 1GTR2VE73CZ288102
      window.axios.get('https://dev.transport.keepneye.com/infobemaster/decode/decodevin/' + vin).then((response) => {
        this.MAKE = response.data.make
        this.MODEL = response.data.model
        this.YEAR = response.data.year.toString()
      }).catch((error) => console.log(error))
    },

    addCustomer: function () {
      if (this.deliverySave) {
        let savedDelivery = {
          'address': this.order.receiverAddress,
          'city': this.order.receiverCity,
          'contact': this.order.receiverContact,
          'fax': this.order.receiverFax,
          'name': this.order.receiverName,
          'receptionEmail': this.order.receiverEmail,
          'postcode': this.order.receiverPostcode,
          'country': this.order.receiverCountry,
          'province': this.order.receiverProvince,
          'phone': this.order.receiverPhone
        }
        db.ref('database/transporter/' + this.companyUID + '/carnet').push().set(savedDelivery)
      }
      if (this.pickupSave) {
        let savedPickup = {
          'address': this.order.transmitterAddress,
          'city': this.order.transmitterCity,
          'contact': this.order.transmitterContact,
          'fax': this.order.transmitterFax,
          'name': this.order.transmitterName,
          'receptionEmail': this.order.transmitterEmail,
          'postcode': this.order.transmitterPostcode,
          'country': this.order.transmitterCountry,
          'province': this.order.transmitterProvince,
          'phone': this.order.transmitterPhone
        }
        db.ref('database/transporter/' + this.companyUID + '/carnet').push().set(savedPickup)
      }
    },

    onResize: _.debounce(function () {
      this.isScreenSmall = window.innerWidth < 800
    }, 50)
  },

  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },

  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },

  computed: {
    // WholesaleExpress has a whole different pricing compared to others so we want to save their data in a different node
    isBillingWholesaleExpress () {
      return (this.selectedOrder.payer === '57aa460a-e2e6-4d83-8832-ca4546d6149c')
    },

    returnPostcodePath () {
      if (this.selectedOrder.transmitterPostcode === '' || this.selectedOrder.receiverPostcode === '') console.log('Empty postcodes', this.selectedOrder.transmitterPostcode, this.selectedOrder.receiverPostcode)
      const transmitterPostcode = this.selectedOrder.transmitterPostcode || 'NoTransmitter'
      const receiverPostcode = this.selectedOrder.receiverPostcode || 'NoReceiver'
      let path = ''

      path = transmitterPostcode.toLowerCase() + receiverPostcode.toLowerCase()
      path = path.split(' ').join('')

      return path
    },

    returnMakeModel () {
      if (this.checkIsUndefined(this.selectedOrder.make)) this.selectedOrder.make = ''
      if (this.checkIsUndefined(this.selectedOrder.model)) this.selectedOrder.model = ''

      const make = this.selectedOrder.make.toLowerCase()
      const model = this.selectedOrder.model.toLowerCase()
      let makeModel = make.split(' ').join('') + model.split(' ').join('')

      makeModel = makeModel.replace('.', '')
      makeModel = makeModel.replace('$', '')
      makeModel = makeModel.replace('#', '')
      makeModel = makeModel.replace('[', '')
      makeModel = makeModel.replace(']', '')

      if (makeModel.length <= 0) makeModel = 'NoMakeModel'
      return makeModel
    },

    formCompleted: function () {
      return (
        this.vehicles.length !== 0 &&
        this.order.receiverName !== '' &&
        this.order.receiverAddress !== '' &&
        this.order.receiverCountry !== '' &&
        this.order.receiverCity !== '' &&
        this.order.receiverPostcode !== '' &&
        this.order.receiverProvince !== '' &&
        this.order.payerName !== '' &&
        this.order.payerAddress !== '' &&
        this.order.payerCountry !== '' &&
        this.order.payerCity !== '' &&
        this.order.payerPostcode !== '' &&
        this.order.payerProvince !== '' &&
        this.order.transmitterName !== '' &&
        this.order.transmitterAddress !== '' &&
        this.order.transmitterCountry !== '' &&
        this.order.transmitterCity !== '' &&
        this.order.transmitterPostcode !== '' &&
        this.order.transmitterProvince !== '' &&
        ((this.isSageOne && this.order.price !== '') || !this.isSageOne))
    },

    sageOneForm () {
      return ((this.$store.state.userInfo.isSageOne && (this.order.sageID !== '' || this.order.sageID !== undefined) || !this.$store.state.userInfo.isSageOne))
    },

    sageIDonly () {
      return this.addressbook.filter(customer => customer.sageID)
    },

    isSageOne () {
      return this.$store.state.userInfo.isSageOne
    },
    isQuickBook () {
      return this.$store.state.userInfo.isQuickbook
    },
    companyUID () {
      return this.$store.state.authorization.company
    },

    uid () {
      return this.$store.state.user.uid
    },

    returnSuggestedPrice () {
      if (this.suggestedPrice) return this.suggestedPrice + '$'
    }
  },

  watch: {
    billingSame: function (val) {
      if (!val) {
        this.order.payerAddress = ''
        this.order.payerCity = ''
        this.order.payerContact = ''
        this.order.payerFax = ''
        this.order.payerName = ''
        this.order.payerPhone = ''
        this.order.payerEmail = ''
        this.order.payerPostcode = ''
        this.order.payerProvince = ''
        this.order.payerCountry = ''
        this.order.sageID = ''
      } else {
        this.order.payerAddress = this.order.receiverAddress
        this.order.payerCity = this.order.receiverCity
        this.order.payerContact = this.order.receiverContact
        this.order.payerFax = this.order.receiverFax
        this.order.payerName = this.order.receiverName
        this.order.payerPhone = this.order.receiverPhone
        this.order.payerEmail = this.order.receiverEmail
        this.order.payerPostcode = this.order.receiverPostcode
        this.order.payerProvince = this.order.receiverProvince
        this.order.payerCountry = this.order.receiverCountry
        this.order.sageID = this.backup.sageIDDelivery || ''
        this.datalist.billing = ''
        this.datalist.billingUid = ''
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#suggested_price {
  background-color: #dfdfdf;
  border-radius: 3px;
}
.table thead th{
  border-bottom: 1px solid #eceeef;
  border-top: none;
}
#action{
  display: flex;
  justify-content: end;
  min-width: 110px;
}
.kne-tab.active{
  color: #f7941e !important;
}
.kne-tab:hover{
  color: #f7941e !important;
}
.view{
  padding-left: 10.5rem;
}

.flexContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.mobileFlexContainer {
  flex-direction: column;
}
.addressContainer {
  width: 50%;
}

.carInfoContainer {
  width: 25%;
}

.miscContainer {
  display:flex;
  flex-direction: column;
  align-content: flex-end;
  width: 25%;
}

label {
  margin-left: 1rem;
}

.toggleSwitch {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
